import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5 7.50003C6.65685 7.50003 8 6.15688 8 4.50003C8 2.84318 6.65685 1.50003 5 1.50003C3.34315 1.50003 2 2.84318 2 4.50003C2 6.15688 3.34315 7.50003 5 7.50003Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 13.5C0 10.7386 2.23858 8.5 5 8.5C7.76142 8.5 10 10.7386 10 13.5C10 13.7761 9.77614 14 9.5 14H0.5C0.223858 14 0 13.7761 0 13.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.1775 14H13.5C13.7761 14 14 13.7761 14 13.5C14 10.7386 11.7614 8.5 9 8.5C8.91895 8.5 8.83835 8.50193 8.75824 8.50574C10.2716 9.64637 11.25 11.4589 11.25 13.5C11.25 13.6737 11.2247 13.8416 11.1775 14ZM8.13225 7.37261C8.40695 7.45548 8.69827 7.50003 9 7.50003C10.6569 7.50003 12 6.15688 12 4.50003C12 2.84318 10.6569 1.50003 9 1.50003C8.69827 1.50003 8.40695 1.54457 8.13225 1.62744C8.82634 2.38388 9.25 3.39248 9.25 4.50003C9.25 5.60758 8.82634 6.61618 8.13225 7.37261Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }